import { render, staticRenderFns } from "./MessagePurchaseOrder.vue?vue&type=template&id=80b408a6&"
import script from "./MessagePurchaseOrder.vue?vue&type=script&lang=js&"
export * from "./MessagePurchaseOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports